// External libraries
import styled from '@emotion/styled';

// Internal modules
import {
  BORDER_FOCUSED_COLOR,
  DEFAULT_BORDER_COLOR,
  HEADER_COLOR,
  NON_INPUT_BORDER_COLOR,
} from '@/styles';
import { paragraphStyles } from './styles';

const LegalTerms = styled.p`
  font-size: 13px;
  font-weight: normal;
  line-height: 1.38;
  padding-left: 37px;
`;

const Container = styled.div`
  border: 1px solid ${NON_INPUT_BORDER_COLOR};
  border-radius: 4px;
  margin-top: 45px;
  padding: 0 18px 18px;
  position: relative;
`;

const Details = styled.p`
  margin-bottom: 12px;
  ${paragraphStyles};
`;

const DetailsList = styled.ul`
  list-style: disc inside;
  margin-bottom: 12px;
  ${paragraphStyles};
`;

const Heading = styled.h3`
  color: ${HEADER_COLOR};
  font-size: 20px;
  font-weight: 300;
  line-height: 1.5;
  margin-bottom: 12px;
`;

const OrDivider = styled.h2`
  align-items: center;
  display: flex;
  margin: 24px -18px;

  &::before,
  &::after {
    background: ${DEFAULT_BORDER_COLOR};
    content: '';
    flex: 1;
    height: 1px;
    margin: 0 18px;
  }
`;

const HiddenSubmitButton = styled.input`
  display: none;
`;

const TipsList = styled.ul`
  font-weight: 500;
  list-style-type: disc;
  margin: 15px 15px 15px 5px;
  padding-left: 20px;

  li {
    margin-left: 5px;
  }
`;

const PomaTermsContainer = styled.span`
  em {
    font-weight: bold;
  }
`;

const QuestionButton = styled.button`
  background-color: transparent;
  border: none;
  margin: 0;
  outline: 0;
  padding: 0;

  span {
    border: 2px solid transparent;
    border-radius: 50%;
    padding: 1px;
  }

  &:focus span {
    border-color: ${BORDER_FOCUSED_COLOR};
  }

  svg {
    position: relative;
    top: 4px;
  }
`;

export {
  Container,
  Details,
  DetailsList,
  Heading,
  HiddenSubmitButton,
  LegalTerms,
  OrDivider,
  PomaTermsContainer,
  QuestionButton,
  TipsList,
};
